const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
  sectionRefreshed: 'section-refreshed',
  swatchTypeChange: 'td:swatch-type-change',
  swatchAdded: 'td:swatch-added',
  swatchRemoved: 'td:swatch-removed',
  swatchRemovedCart: 'td:swatch-removed-cart',
};

const SECTION_REFRESH_RESOURCE_TYPE = {
  product: 'product',
};
